import React, { MouseEventHandler, useState } from "react"
import { Alert, Button, Form, Modal } from "react-bootstrap"
import { XCircle } from "react-bootstrap-icons"
import Dropzone from "react-dropzone-uploader"
import { useTranslation } from "react-i18next"
import uploadIcon from "./uploadIcon.svg"

const BulkUploadModal = ({
    loading,
    show,
    setShow,
    handleClose,
    handleSubmit,
    setUploadedFile
}: {
    loading: boolean
    show: string
    setShow: Function
    handleClose: Function
    handleSubmit: Function
    setUploadedFile: Function
}) => {
    const { t } = useTranslation()
    const [error, setError] = useState("")
    const handleChangeStatus = ({ meta, file }: { meta: any; file: any }, status: string) => {
        if (status === "rejected_file_type") {
            setError("File has been rejected, please use .csv, .xlsx files")
        }
        if (status === "done") {
            const uploadForm = document.getElementById("bulk-upload") as HTMLFormElement
            const formObj = new FormData(uploadForm)
            formObj.append("rates", file)
            setUploadedFile(formObj)
        }
    }
    return (
        <Modal
            size={"lg"}
            show={show === "bulkUploadModal"}
            onHide={() => {
                setShow("")
                setUploadedFile(null)
            }}
            backdrop="static"
            keyboard={false}
            id="bulk-upload-rates">
            <Modal.Header closeButton>
                <Modal.Title className={"pb-0"}>{t("Upload your file")}</Modal.Title>
            </Modal.Header>
            <p className="mb-3 px-3">
                {t("For sample excel file click ")}
                <a
                    className="tr-pointer text-primary"
                    onClick={() =>
                        window.open(
                            `${process?.env?.REACT_APP_BASE_URL_PRICING}/api/bulk/rates/format/v1`,
                            "_blank"
                        )
                    }>
                    {t("here")}
                </a>
            </p>
            <Modal.Body>
                {error && error !== "" && (
                    <Alert
                        className="d-flex align-items-center  my-2"
                        onClose={() => setError("")}
                        dismissible
                        variant="danger">
                        <XCircle className="text-danger" /> &nbsp;&nbsp; {t(error)}
                    </Alert>
                )}
                <Form id="bulk-upload">
                    <Dropzone
                        multiple={false}
                        inputContent={
                            <>
                                <img src={uploadIcon} />
                                <br />
                                <span className="text-primary">Browse</span>&nbsp;
                                <span className="muted-text">{t("your files")}</span>
                            </>
                        }
                        accept={
                            "text/csv, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                        }
                        maxFiles={1}
                        onChangeStatus={handleChangeStatus}
                    />
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose as MouseEventHandler<HTMLButtonElement>}>
                    {t("Cancel")}
                </Button>

                <Button
                    onClick={() => {
                        handleSubmit()
                        handleClose()
                    }}
                    className="btn btn-primary"
                    type="submit">
                    {loading ? <div className="spinner-border text-light" role="submit"></div> : t("Done")}
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default BulkUploadModal
